import { render, staticRenderFns } from "./SerieProgress.vue?vue&type=template&id=4b04acd6&scoped=true&"
import script from "./SerieProgress.vue?vue&type=script&lang=js&"
export * from "./SerieProgress.vue?vue&type=script&lang=js&"
import style0 from "./SerieProgress.vue?vue&type=style&index=0&id=4b04acd6&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b04acd6",
  null
  
)

export default component.exports